import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrerPar',
})
export class FiltrerParPipe implements PipeTransform {
  transform<T>(values: T[], key: keyof T, value: any): T[] {
    return values.filter((x) => x[key] === value);
  }
}
